import { IOmniaCommand, IOmniaCommandGroup } from "../../types"
import { defineDirective } from "../../utils/angular"
import { isFunction, isUndefined } from "../../utils/utils"

export function createPopupMenu(): ng.IDirective {

    return defineDirective(PopupMenuCtrl, "shared/components/popupMenu/popupMenu.html", {
        commandsGroups: "="
    });

};

export class PopupMenuCtrl {

    static $inject = ["$scope"];

    protected commandsGroups: IOmniaCommandGroup[];

    constructor(protected $scope: ng.IScope) {

    }

    getIconCssClass(command: IOmniaCommand) {
        const icon = command?.icon
        return icon && (icon.indexOf(" ") >= 0)
            ? icon
            : "icon icon-" + icon
    }

    foregroundCommandGroups(): IOmniaCommandGroup[] {
        if (isUndefined(this.commandsGroups)) return [];

        return this.commandsGroups.filter((v) => v.foreground);
    }

    backgroundCommandGroups(): IOmniaCommandGroup[] {
        if (isUndefined(this.commandsGroups)) return [];

        return this.commandsGroups.filter((v) => !v.foreground);
    }

    canExecute(command: IOmniaCommand, group: IOmniaCommandGroup) {

        var handler = command.canExecute;
        if (!isFunction(handler)) return true;

        return handler.apply(command, [group.datacontext]);

    }

    execute(command: IOmniaCommand, group: IOmniaCommandGroup) {

        if (!this.canExecute(command, group)) return;

        var handler = command.execute;

        if (isFunction(handler)) {
            handler.apply(command, [group.datacontext]);
        }

    }
}
